import React from 'react';
import SVGInline from 'components/SVGInline/SVGInline';
import { useAriaOnlyNotification } from 'components/Notification/Notification';
import icons from 'style';
import translate from 'utils/fnTranslate';
import { StyledButton } from 'components/Buttons/FavoriteButton/FavoriteButton.css';

type ButtonPropType = {
    isFavorite: boolean;
    isPrimary?: boolean;
    onClick?: (e) => void;
    labels?: { add: string; remove: string };
    assetName?: string;
};

export const FavoriteButton: React.FC<ButtonPropType> = ({
    isFavorite,
    isPrimary = false,
    onClick,
    assetName,
    labels = {
        add: 'BUTTON_ADD_TO_WORLD',
        remove: 'BUTTON_REMOVE_FROM_WORLD',
    },
}) => {
    const favoriteNotification = useAriaOnlyNotification();

    const handleClick = (e) => {
        if (onClick) onClick(e);

        const toastString = isFavorite
            ? translate('ARIA_TOAST_FAV_ASSET_REMOVE', { assetName })
            : translate('ARIA_TOAST_FAV_ASSET_ADD', { assetName });
        favoriteNotification(toastString);
    };

    return (
        <StyledButton
            key={'cta'}
            label={!isFavorite ? translate(labels.add) : translate(labels.remove)}
            isPrimary={isPrimary}
            onClick={handleClick}
            data-event-name={'click'}
            data-track-id={'button_cta'}
            data-test-id={'tv-detailscreen-addtoworldbutton'}
            aria-checked={isFavorite}
        >
            {!isFavorite ? (
                <SVGInline data-test-id={'emptyHeartIcon'} svg={icons.emptyHeartIcon} />
            ) : (
                <SVGInline data-test-id={'fullHeartIcon'} svg={icons.heartIcon} />
            )}
        </StyledButton>
    );
};
